const initDeviceDetection = () => {
  const userAgent = window?.navigator?.userAgent
  if (userAgent.includes('Windows')) {
    document.querySelector('body').classList.add('is-windows')
  }
  if (userAgent.includes('Macintosh')) {
    document.querySelector('body').classList.add('is-mac')
  }
  if (userAgent.includes('iPhone')) {
    document.querySelector('body').classList.add('is-iphone')
  }
  if (userAgent.includes('Android')) {
    document.querySelector('body').classList.add('is-android')
  }
}
export default initDeviceDetection
